import {defineStore} from 'pinia'

export const useScrollPositionStore = defineStore('scrollPositionStore', {
    state: () => {
        return {
            scrollPosition: {x: 0, y:0}
        }
    },
    actions: {
        storeScrollPosition() {
            this.scrollPosition = {
                x: window.pageXOffset  // All browsers, except IE9 and earlier
                    || document.documentElement.scrollLeft, // IE9 and earlier
                y: window.pageYOffset  // All browsers, except IE9 and earlier
                    || document.documentElement.scrollTop // IE9 and earlier
            };
        },
        resetScrollPosition() {
            this.scrollPosition = {x: 0, y: 0};
        },
        scrollToStoredPosition() {
            if (this.scrollPosition !== {} && this.scrollPosition.y !== undefined && this.scrollPosition.x !== undefined) {
                window.scrollTo(this.scrollPosition.x, this.scrollPosition.y);
            }
        }
    }
})
